import { StateCreator } from 'zustand';
import { SecondaryMenuSlice, SecondaryMenuSliceState } from './index.types';

const initialState: SecondaryMenuSliceState = {
  isSecondaryMenuOpen: false,
};

/** Zustand slice for the secondary menu open state on small screens. */
export const createSecondaryMenuSlice: StateCreator<SecondaryMenuSlice> = (
  set
) => ({
  ...initialState,
  setIsSecondaryMenuOpen: (isSecondaryMenuOpen) => {
    set({ isSecondaryMenuOpen });
  },
});
